import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Inverse of ProtectedRoute: guards pages that only make sense when signed OUT
// (register, founding, login). An already-authenticated user is redirected into the
// app, so they can never re-open the sign-up form or create a duplicate account -
// even by hitting the URL directly or clicking a stale CTA.
export default function GuestRoute({ children }) {
  const { user, loading } = useAuth();

  // Still resolving the session: render nothing briefly rather than flashing the
  // sign-up form to a user who is about to be redirected.
  if (loading) return null;

  // An unverified session is not "signed in" as far as these pages are concerned - sending
  // it to /app would only bounce off ProtectedRoute and land on verification anyway. Going
  // there directly saves the round trip and, more importantly, means /register and /login
  // never flash for someone mid-signup.
  if (user && !(user.email_confirmed_at || user.confirmed_at)) {
    return <Navigate to="/verify-email" replace />;
  }

  if (user) return <Navigate to="/app" replace />;

  return children;
}
